import getFieldFactory from "../../components/customRoute/Endpoints/Endpoint/FieldFactory";

function addSubField( state, action ) {
	return {
		...state,
		settings: {
			...state.settings,
			endpoints: [
				...state.settings.endpoints.map((el, index) => {
					if ( index === action.payLoad.endpointId ) {
            action.payLoad.field[0].order
              = el[action.payLoad.parentGroup][action.payLoad.currentItem][action.payLoad.group].length;

						el[action.payLoad.parentGroup][action.payLoad.currentItem][action.payLoad.group] = [
							...el[action.payLoad.parentGroup][action.payLoad.currentItem][action.payLoad.group],
							action.payLoad.field[0]
						];
					}
					return el;
				}),
			]
		}
	};
}

function changeSubField( state, action ) {
	return {
		...state,
		settings: {
			...state.settings,
			endpoints: [
				...state.settings.endpoints.map((el, index) => {
					if ( index === action.payLoad.endpointId ) {
						const fields = el[action.payLoad.action][action.payLoad.currentItem][action.payLoad.group][action.payLoad.groupId].fields
						if ( action.payLoad.inputType === 'checkboxes' ) {
							if ( -1 === fields[action.payLoad.fieldIndex].value.indexOf( action.payLoad.value ) ) {
								fields[action.payLoad.fieldIndex] = {
									...fields[action.payLoad.fieldIndex],
									value: [
										...fields[action.payLoad.fieldIndex].value,
										action.payLoad.value
									]
								};
							} else {
								fields[action.payLoad.fieldIndex].value = fields[action.payLoad.fieldIndex].value.filter(
									el => el !== action.payLoad.value
								);
							}
						} else {
							fields[action.payLoad.fieldIndex] = {
								...fields[action.payLoad.fieldIndex],
								value: action.payLoad.value
							};
						}

						if ( action.payLoad.group === 'tableSelection' ) {
							el[action.payLoad.action][action.payLoad.currentItem].defaultFields = [];

							if ( typeof el[action.payLoad.action][action.payLoad.currentItem].filters !== undefined ) {
								el[action.payLoad.action][action.payLoad.currentItem].filters = [];
							}

							el[action.payLoad.action][action.payLoad.currentItem].output = [];
							el[action.payLoad.action][action.payLoad.currentItem].order = [
								{
									name: 'order',
									label: '',
									fields: [
										getFieldFactory().getSourceField(),
										{
											id: 'value',
											inputType: 'select',
											source: 'order',
											sourceName: 'name',
											sourceValue: 'value',
											value: '',
											label: 'Order',
											defaultValue: 'Select an order',
											dynamic: true
										},
										getFieldFactory().getParametersField(),
									],
								}
							];
							el[action.payLoad.action][action.payLoad.currentItem].orderby = [
								{
									name: 'orderby',
									label: '',
									fields: [
										getFieldFactory().getSourceField(),
										{
											id: 'value',
											inputType: 'select',
											sourceName: 'name',
											sourceValue: 'value',
											source: 'dynamicFetch',
											value: '',
											label: 'Order by',
											defaultValue: 'Select an order',
											dynamic: true,
											dynamicFetch: true,
											fetchType: 'columns'
										},
										getFieldFactory().getParametersField(),
									],
								}
							];
						}
					}
					return el;
				}),
			]
		}
	};
}

function removeSubField( state, action ) {
	return {
		...state,
		settings: {
			...state.settings,
			endpoints: [
				...state.settings.endpoints.map((el, index) => {
					if ( index === action.payLoad.endpointId ) {
						const currentItem = el[action.payLoad.action][action.payLoad.currentItem];
						currentItem[action.payLoad.group] = currentItem[action.payLoad.group].filter(
							( el, groupIndex ) => groupIndex !== action.payLoad.index
						);
					}
					return el;
				}),
			]
		}
	};
}

export { addSubField, removeSubField, changeSubField };
